<template>
  <div class="MomentsReportFilterBar">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1 padding-right-0Px text-align-left">
        </div>    
        <div class="col-md-3 col-lg-3 padding-right-0Px">
          <span class="float-left"><b>From Date:</b></span>
          <span>
          <date-picker v-model="fromTS" :config="config"></date-picker>
          </span>
        </div>
        <div class="col-md-5 col-lg-5">
          <span class="float-left text-align-left col-xs-12 col-sm-12 col-md-12 col-lg-12"><b>Moment(s):</b></span>
          <span>
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" id="vueMultiSelect">
              <vue-multi-select
                search
                :filters="filters"
                btnClass="cssClass"
                v-model="selectedValues"
                :btnLabel="btnLabel"
                :options="options"
                :selectOptions="data" />
            </div>
          </div>
          </span>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px padding-left-0Perc">
          <!-- AK: Intentionally added below line in order to move down buttons exactly on the same like. -->
          <span class="opacity-0">From Date:</span>
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" v-on:click="checkAndEmit($event, false)" :disabled="!getEnableBtnsValue">View</button>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px">
          <!-- AK: Intentionally added below line in order to move down buttons exactly on the same like. -->
          <span class="opacity-0">From Date:</span>
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState" :disabled="!getEnableBtnsValue">Export</button>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px text-align-left">
        </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>      
  </div>
</div>    
</template>

<script>
import vueMultiSelect from 'vue-multi-select'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'vue-multi-select/dist/lib/vue-multi-select.css'
import { constants } from '@/utils/constants'
import { courseService } from '@/server-util/course-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import forEach from 'lodash/forEach'
export default {
  props: ['showExport', 'enableBtns'],
  created: function () {
    this.setDefaultValues()
    this.getAllMentoraMoments()
  },
  data: function () {
    return {
      enableViewAndExportBtns: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      btnLabel: selectedValues => selectedValues.length > 0 ? selectedValues.length === 1 ? '1 Moment is selected' : selectedValues.length + ' Moments are selected' : 'Select Single/Multiple Mentora Moment course(s)',
      selectedValues: [],
      data: [],
      options: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      filters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      fromTS: new Date(),
      config: {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true,
        maxDate: ''
      }
    }
  },
  methods: {
    setDefaultValues: function () {
      this.fromTS = dmAdminUtils.getCurrentEst()
      this.config.maxDate = new Date()
      this.data = []
      // this.enableViewAndExportBtns = this.getEnableBtnsValue
      if (this.getMomentCourseList.length > 0) {
        forEach(this.getMomentCourseList, (obj) => {
          var objToPush = {
            name: obj.LongTitle,
            coursemasterid: obj.CourseMasterId,
            hasProcessed: false
          }
          this.data.push(objToPush)
        })
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedValues.length > 0) {
        var objToReturn = {
          isExportBtnClicked: isExportBtnClicked,
          isViewBtnClicked: !isExportBtnClicked,
          selectedMomentsArr: this.selectedValues,
          fromTS: this.fromTS
        }
        this.$emit('selectedValues', objToReturn)
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one moment'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAllMentoraMoments: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If Mentora Moments are not available then only show spinner
        if (storeObj.state.mentoraMomentCourseList.length === 0) {
          _this.$store.state.isLoading = true
        }
        courseService
          .listMoments(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.mentoraMomentCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                _this.$store.state.isLoading = false
                _this.setDefaultValues()
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined loading MENTORA MOMENT LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'vue-multi-select': vueMultiSelect,
    'date-picker': datePicker
  },
  computed: {
    getEnableBtnsValue: {
      get: function () {
        return this.enableBtns
      }
    },
    getMomentCourseList: {
      get: function () {
        return this.$store.state.mentoraMomentCourseList
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {},
  name: 'MomentsReportFilterBar'
}
</script>

<style scoped>
.MomentsReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.padding-6px-6px{
  padding: 6px 6px;
}
.width-auto {
  width: auto;
}
.padding-left-2Point5Perc {
  padding-left: 2.5%;
}
.padding-left-3Perc {
  padding-left: 3%;
}
.width-3Perc {
  width: 3%;
}
.width-13Point4Perc {
  width:13.4%;
}
.padding-left-0Perc {
  padding-left: 0%;
}
.padding-left-3Point3Perc {
  padding-left:3.3%;
}
</style>
<style>
#vueMultiSelect .select {
  width: 100%;
}
#vueMultiSelect button.btn-select {
  min-width: 100%;
}
#vueMultiSelect .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelect .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelect .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelect ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
-moz-hyphens: none;
}
.opacity-0 {
  opacity: 0;
}
.float-left {
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/moments_report/MomentsReportFilterBar.vue